import { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { isTopic } from 'src/common/utils/guideItemTypes';
import sortGalleryItems from './utils/sortGalleryItems';
import getGalleryItem from './utils/getGalleryItem';
import getNumberOfColumns from './utils/getNumberOfColumns';
import css from './gallery.module.scss';

const gridPctUnit = 100 / 6;

export default class CarouselItems extends Component {
  static propTypes = {
    pageOffset: PropTypes.number.isRequired, // from react-motion
    items: PropTypes.array.isRequired,
    numRows: PropTypes.number.isRequired,
    getStyles: PropTypes.func.isRequired,
    breakpoint: PropTypes.number.isRequired,
    isExtendedInfoEnabled: PropTypes.bool,
  };

  render() {
    const {
      items,
      numRows,
      pageOffset,
      breakpoint,
      getStyles,
      isExtendedInfoEnabled,
    } = this.props;
    const sortedArray = sortGalleryItems(items, numRows);

    return (
      <div
        data-testid="carousel"
        className={css.carousel}
        style={{ left: `-${pageOffset * 100}%` }}
      >
        {sortedArray.map((itemsArray, rowIndex) => (
          <div className={css.row} key={`row-${rowIndex}`}>
            {itemsArray.map((guideItem, itemsArrayIndex) => {
              const { Component: ItemComponent, requiredSlots } =
                getGalleryItem(guideItem);

              const itemIndex =
                parseInt(get(guideItem, 'index', itemsArrayIndex + 1), 10) - 1;
              const { tileSize } = getStyles(guideItem.style);
              const numberOfColumns = getNumberOfColumns(
                requiredSlots,
                breakpoint,
                tileSize,
              );
              const tileWidth = `${gridPctUnit * numberOfColumns}%`;

              // these variables below are used for automation testing
              let nextGuideId;
              let title;
              let nextTopicId;

              if (isTopic(guideItem.guideId)) {
                nextGuideId = get(
                  guideItem,
                  'properties.parentProgram.destinationInfo.id',
                );
                title = get(
                  guideItem,
                  'properties.parentProgram.destinationInfo.seoName',
                );
                nextTopicId = guideItem.guideId;
              } else {
                nextGuideId = guideItem.guideId;
                title = get(guideItem, 'properties.seoInfo.title');
              }
              return (
                <div
                  data-testid={`carouselGuideItem-${itemIndex}`}
                  key={`row-${rowIndex}item-${itemIndex}id-${guideItem.guideId}`}
                  className={css.item}
                  style={{ width: tileWidth }}
                  data-nexttitle={title}
                  data-nextguideitem={nextGuideId}
                  data-nexttopicid={nextTopicId}
                >
                  <ItemComponent
                    guideItem={guideItem}
                    index={itemIndex}
                    getStyles={getStyles}
                    isExtendedInfoEnabled={isExtendedInfoEnabled}
                    containerClassName={css.carouselItemContainer}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  }
}
